/** The backend's `{success, message, data}` envelope. */
export interface ServiceReply<T> {
  success?: boolean;
  message?: string;
  error?: string;
  data?: T;
}

/** The app's `handleXHRResponse`: a `success: false` reply carries `message || error`. */
export function failedReplyMessage(reply: unknown): string | undefined {
  const envelope = reply as ServiceReply<unknown> | null | undefined;
  if (envelope?.success !== false) return undefined;
  return envelope.message || envelope.error || 'The request failed';
}

export function throwIfFailedReply(reply: unknown): void {
  const message = failedReplyMessage(reply);
  if (message !== undefined) throw new Error(message);
}
